import axios from "axios"
import { formPdfEndpoint } from "utils/env"
import { toISODateFormat, toVerboseDateFormat } from "utils/date"

const AUDIENCE_ID_NEWSLETTER = "f4537d23d5" // shop-newsletter
const AUDIENCE_ID_SCHOOLS = "f9c2737b82"
const AUDIENCE_ID_PRO = "139b377938"
// const AUDIENCE_ID_OLD_CONTACTS = "bf45470235" // deprecated

const getLocaleByLanguage = (language) => {
  if (language === "swedish") return "sv-FI"
  if (language === "english") return "en-FI"
  return "fi-FI"
}

export const subscribeToWebinarPro = async (formData, locale) => {
  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      webinarDate: toISODateFormat(formData.date.time),
      webinarTime: toVerboseDateFormat(formData.date.time),
      locale,
      listId: AUDIENCE_ID_PRO,
      tags: formData?.date?.tag
        ? ["webinar-18.01", "pro", formData.date.tag]
        : ["webinar-18.01", "pro"],
    }),
  )
}

export const subscribeToSchoolTrainings = async (formData, locale) => {
  const tags = ["schools"]

  if (formData.date?.tag) {
    tags.push(formData.date.tag)
  }

  if (formData.date?.audience !== "general") {
    tags.push("form-webinar-training")
  }

  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      webinarDate: toISODateFormat(formData.date.time),
      webinarTime: toVerboseDateFormat(
        formData.date.time,
        getLocaleByLanguage(formData.date?.language),
      ),
      webinarLanguage: formData.date?.language,
      webinarSlug: formData.date?.tag,
      city: formData.city?.id,
      grade: formData.grade?.id,
      certificate: formData.certificate
        ? formData.certificate.toString()
        : "not set",
      locale,
      listId: AUDIENCE_ID_SCHOOLS,
      tags,
      alsoSubscribe: formData.somevahti ? [AUDIENCE_ID_NEWSLETTER] : [],
      audience: formData.date?.audience,
      onlineAttendance: formData.onlineAttendance === true ? "true" : "false",
      orderLunch: formData.orderLunch === true ? "true" : "false",
    }),
  )
}

export const getWebinarRecordings = async (formData, locale) => {
  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      locale,
      listId: AUDIENCE_ID_PRO,
      tags: ["form-webinar-recording", "pro", "webinar-18.01"],
    }),
  )
}

export const getSchoolsPdf = async (formData, locale) => {
  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      locale,
      listId: AUDIENCE_ID_SCHOOLS,
      tags: ["contact-form-pdf", "schools"],
    }),
  )
}

export const getEuReportByTag = async (formData, locale, tag) => {
  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      locale,
      listId: AUDIENCE_ID_SCHOOLS,
      tags: formData.somevahti ? [tag, "schools"] : [tag],
      alsoSubscribe: formData.somevahti ? [AUDIENCE_ID_NEWSLETTER] : [],
    }),
  )
}

export const getEuReports = async (formData, locale, reportTags = []) => {
  const reportPromises = reportTags.map((tag) =>
    getEuReportByTag(formData, locale, tag),
  )
  return Promise.all(reportPromises)
}

export const subscribeToNewsletter = async (formData, locale, segment = "") => {
  return await axios.post(
    `${formPdfEndpoint}`,
    JSON.stringify({
      ...formData,
      locale,
      listId: AUDIENCE_ID_NEWSLETTER,
      tags:
        segment === "schools"
          ? ["form-newsletter", "schools"]
          : ["form-newsletter"],
    }),
  )
}
